export default class DataHelper {
    static process(data) {
        data.cars = data.cars.map((c) => this.processCar(c));
        data.carMap = data.cars.reduce((map, car) => {
            map[`${car.gradeCode}-${car.engineTDCode}`] = car;
            return map;
        }, {});

        data.gradeMap = data.grades.reduce((map, grade) => {
            map[grade.code] = grade;
            return map;
        }, {});

        data.engineMap = data.engines.reduce((map, engine) => {
            map[engine.code] = engine;
            return map;
        }, {});

        data.colourMap = data.colours.reduce((map, colour) => {
            map[colour.code] = colour;
            return map;
        }, {});

        data.trimMap = data.trims.reduce((map, trim) => {
            map[trim.code] = trim;
            return map;
        }, {});

        data.additionalProductsMap = data.additionalProducts.reduce((map, ap) => {
            map[ap.code] = ap;
            return map;
        }, {});

        return data;
    }

    static processCar(car) {
        car.colourTrimMap = car.colourTrims.reduce((map, ct) => {
            map[`${ct.colour}-${ct.trim}`] = ct;
            return map;
        }, {});
        return car;
    }
}